import BillingsOrderForwardTaxiTaxiAddRequest, {
  BillingsOrderForwardTaxiTaxiAddRequestBody,
} from "./billings-order-forward-taxi-taxi-add.request";

const createBody = (
  request: BillingsOrderForwardTaxiTaxiAddRequest,
): BillingsOrderForwardTaxiTaxiAddRequestBody => {
  return {
    billingContributions: request.billingContributions,
    billingNodes: request.billingNodes,
  };
};

const billingsOrderForwardTaxiTaxiAddRequestFactory = {
  createBody,
};

export default billingsOrderForwardTaxiTaxiAddRequestFactory;
